// Copyright (c) 2018 Deere & Company

import KeyValuePair from './key-value-pair';
import t from 'tcomb';

const DbsClaimTypes = t.struct({
    allowedClaimTypes: t.list(KeyValuePair, 'allowedClaimTypes'),
    selectedClaimTypes: t.list(KeyValuePair, 'selectedClaimTypes')
}, {
    name: 'DbsClaimTypes',
    strict: true
});

export const getDefaultState = () => new DbsClaimTypes({
    allowedClaimTypes: [],
    selectedClaimTypes: []
});

export default DbsClaimTypes;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dbs-claim-types.js